export default "__VITE_ASSET__67db8916__"